import { useMemo } from 'react';
import { BiAddMediaClickOrigin } from '../../../constants/Bi';
import { bi } from '../../../services/loggers/bi';
import { addMediaButtonClick } from '@wix/bi-logger-media-manager-g6/v2';

export const useTrackAddMediaButtonClickAnalytics = () =>
  useMemo(
    () => ({
      trackAddMediaButtonClickSideBar: () =>
        bi.logger().report(addMediaButtonClick({ clickOrigin: BiAddMediaClickOrigin.SideBar })),
      trackAddMediaButtonClickFirstTime: () =>
        bi.logger().report(addMediaButtonClick({ clickOrigin: BiAddMediaClickOrigin.FirstTime })),
      trackAddMediaButtonClickUploadViewDetails: () =>
        bi.logger().report(addMediaButtonClick({ clickOrigin: BiAddMediaClickOrigin.UploadingViewDetails })),
      trackAddMediaButtonClickContextMenu: () =>
        bi.logger().report(addMediaButtonClick({ clickOrigin: BiAddMediaClickOrigin.ContextMenu })),
      trackAddMediaButtonClickStartAdding: () =>
        bi.logger().report(addMediaButtonClick({ clickOrigin: BiAddMediaClickOrigin.StartAdding })),
      trackAddMediaButtonClickEmptyFolderOrFilter: () =>
        bi.logger().report(addMediaButtonClick({ clickOrigin: BiAddMediaClickOrigin.EmptyFolder })),
    }),
    [],
  );
